import React, { ReactElement, useEffect, useState } from "react";
import { useAppDispatch, useAppSelector } from "redux/hooks";
import { Translate } from "react-redux-i18n";
import { Button, Grid, Box } from "@mui/material";
import UserInformation from "components/wallet/UserInformation";
import WalletInformation from "components/wallet/WalletInformation";
import CustomBackdrop from "components/shared/CustomBackdrop";
import {
  PayloadData,
  createWalletRequested,
  editWalletRequested,
} from "redux/wallet/walletSlice";

import styles from "./styles.module.scss";
interface IProps {
  walletId?: number;
  action: string;
  walletTypeOptions?: any;
  hasExpandIcon: boolean;
  isExpandClicked: boolean;
  // count: number;
  index: number;
  isWalletOpen: boolean;
  setWallet?: React.Dispatch<React.SetStateAction<boolean>>;
  // setCount?: React.Dispatch<React.SetStateAction<number>>;
  setExpandBtnClicked?: React.Dispatch<React.SetStateAction<boolean>>;
  setExpandIcon?: React.Dispatch<React.SetStateAction<boolean>>;
  handleCancel: (event?: unknown, reason?: string | undefined) => void;
}

export default function CreateEditWallet({
  walletId,
  action,
  walletTypeOptions,
  hasExpandIcon,
  isExpandClicked,
  // count,
  index,
  isWalletOpen,
  // setCount,
  setWallet,
  setExpandBtnClicked,
  setExpandIcon,
  handleCancel,
}: IProps): ReactElement {
  const dispatch = useAppDispatch();
  const isFetchingWalletToEdit = useAppSelector((state) => state.wallet.isFetchingWalletToEdit);
  const visible = useAppSelector((state) => state.alert.visible);
  const success = useAppSelector((state) => state.alert.success);
  const walletToEdit = useAppSelector((state) => state.wallet.walletToEdit);
  const [change_password, setIsChangePassword] = useState<boolean>(action === "create" ? true : false)
  const [walletData, setWalletData] = useState<PayloadData>({
    wallet: {
      wallet_type_id: walletTypeOptions[0]?.id,
    },
    user: {
      username: "",
      password: "",
      c_password: "",
      email: "",
      phone: "",
      firstname: "",
      lastname: "",
      password_change: change_password
    },
  });
  const handleChange = (name: string, value: string | boolean, group: string) => {
    setWalletData({
      ...walletData,
      [group]: {
        ...walletData[group],
        [name]: value,
      },
    });
  };

  const handleSubmit = (event: React.FormEvent) => {
    event.preventDefault();
    if (walletData && walletData.user && walletId) {
      if (action === "create" && walletData.user.password && walletData.user.password.length >= 5) {
        dispatch(
          createWalletRequested({
            id: walletId,
            data: walletData,
            index: index,
          })
        );
      } else if (action === "edit") {
        walletData.user.password ?
          (walletData.user.password.length >= 5 || walletData.user.password.length < 1) &&
          dispatch(
            editWalletRequested({
              id: walletId,
              data: walletData,
              index: index,
            })
          )
          :
          dispatch(
            editWalletRequested({
              id: walletId,
              data: walletData,
              index: index,
            })
          );
      }
    }
  };

  const handleChangePassword = (value: boolean) => {
    setIsChangePassword(value)
  };

  useEffect(() => {
    walletToEdit && setWalletData({
      ...walletToEdit,
      ["user"]: {
        ...walletToEdit["user"],
        ["password_change"]: change_password,
      },
    });
  }, [walletToEdit]);

  useEffect(() => {
    setWalletData({
      ...walletData,
      ["user"]: {
        ...walletData["user"],
        ["password_change"]: change_password,
      },
    });
  }, [change_password]);

  useEffect(() => {
    if (action === "create" && visible && success) {
      !isExpandClicked && setExpandBtnClicked && setExpandBtnClicked(true);
      // !hasExpandIcon && setCount && setCount(count + 2);
      !hasExpandIcon && setExpandIcon && setExpandIcon(true);
      !isWalletOpen && setWallet && setWallet(true);
    }
    visible && success && handleCancel();
  }, [visible]);

  return (
    <form onSubmit={handleSubmit}>
      <Grid container spacing={2}>
        <Grid
          item
          xs={12}
          md={12}
        >
          <Grid item xs={12} >
            <p className={styles.sectionLabel}>
              <Translate value="walletInformation.label" />
            </p>
            <WalletInformation
              data={walletData}
              walletTypeOptions={walletTypeOptions}
              action={action}
              handleChange={handleChange}
            />
          </Grid>
        </Grid>
        <Grid item xs={12}>
          <p className={styles.sectionLabel}>
            <Translate value="userInformation.label" />
          </p>
          <UserInformation
            data={walletData}
            action={action}
            handleChangePassword={handleChangePassword}
            change_password={change_password}
            handleChange={handleChange}
          />
        </Grid>
        < Box className={styles.buttons}>
          <Button variant="contained" color="error" onClick={handleCancel}>
            <Translate value="buttons.cancel" />
          </Button>
          <Button variant="contained" color="success" type="submit">
            <Translate value="buttons.save" />
          </Button>
        </Box>
      </Grid>
      {
        isFetchingWalletToEdit &&
        <CustomBackdrop />

      }
    </form >
  );
}
